<template>
  <v-app>
    <v-snackbar
      :value="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      @input="toggleSnackbar"
    >
      <div class="d-flex align-center">
        {{ snackbar.text }}
        <v-spacer />
        <v-icon dark>
          {{ snackbar.icon }}
        </v-icon>
      </div>
    </v-snackbar>
    <v-dialog
      v-model="loading"
      fullscreen
      hide-overlay
      transition="fade-transition"
    >
      <v-container fill-height>
        <v-row
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="primary lighten-5"
            size="64"
          />
        </v-row>
      </v-container>
    </v-dialog>
    <v-main
      v-if="!loading"
      :class="$route.meta.greyBackground && $store.state.mobile ? 'grey lighten-5' : ''"
    >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['countryGetter']),
    ...mapState([
      'snackbar',
    ]),
  },
  created() {
    this.$store.commit('SET_BREAKPOINT', this.$vuetify.breakpoint);
    const cookie = this.$store.$cookie;
    const account = cookie.get('account') ? JSON.parse(cookie.get('account')) : null;
    this.loading = true;
    this.getWebConfigAsync().then(() => {
      if (account) {
        this.$store.dispatch('logInAsync', {
          account: account.account,
          password: account.password,
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
      const usedCountry = localStorage.getItem('country');
      const usedLanguage = localStorage.getItem('language');
      if (usedCountry) {
        this.$store.commit('SET_USED_COUNTRY', usedCountry);
      } else {
        this.$store.commit('SET_USED_COUNTRY', null);
      }
      if (usedLanguage) {
        this.$store.commit('SET_LANGUAGE', JSON.parse(usedLanguage));
      }
      if (this.$store.getters.languageGetter === '1') {
        this.$vuetify.rtl = true;
        document.title = this.$store.state.webConfig.companyName;
      } else {
        document.title = this.$store.state.webConfig.companyNameEn;
      }
    });
  },
  methods: {
    ...mapActions(['getWebConfigAsync']),
    toggleSnackbar(v) {
      if (!v) {
        this.$store.commit('CLOSE_SNACKBAR');
      }
    },
  },
};
</script>
